import { render, staticRenderFns } from "./CArticlePrevnext.vue?vue&type=template&id=e1f09ac4&"
import script from "./CArticlePrevnext.vue?vue&type=script&lang=ts&"
export * from "./CArticlePrevnext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports